
if (!window.Reflect) {
    window.Reflect = {
        apply: (target, thisArgument, argumentsList) => {
            return target.apply(thisArgument, argumentsList)
        },
        defineProperty: (target, propertyKey, attributes) => {
            return Object.defineProperty(target, propertyKey, attributes)
        },
        deleteProperty: (target, propertyKey) => {
            delete target[propertyKey]
        },
        getOwnPropertyDescriptor: (source, prop) => {
            return Object.getOwnPropertyDescriptor(source, prop)
        },
        getOwnPropertyNames: (source) => {
            return Object.getOwnPropertyNames(source)
        }
    }
}




// WEBPACK FOOTER //
// ./resources/assets/js/lib/polyfill/reflect.js